import React from "react"
import getValidation from "./getValidation"
import Validation, {Schema} from "./index"

export interface ValidationProps<T = any> {
  /** Form fileds normally have a `name` field, used for console.log */
  name?: string | null
  validation?: Schema<T> | null
}

export interface ValidationState<T = any> {
  validation?: Schema<T> | null
  /** ValidationInput will look for value on the state */
  value?: T | null
  /** ValidationInput will add to errorMsg on error */
  errorMsg?: string | null
}

interface Component<T = any> extends React.Component<ValidationProps<T>, ValidationState> {}

interface PureComponent<T = any> extends React.PureComponent<ValidationProps<T>, ValidationState> {}

export type validate = (currentScreen?: string | null) => Promise<any> | null

interface InputValidation {
  component: Component | PureComponent
  validator: {validate: validate}
  validate: validate

  update(nextProps: ValidationProps, nextState: ValidationState): void
}

export default class implements InputValidation {
  component: Component | PureComponent
  validator: {validate: validate; component?: Component | PureComponent}

  constructor(component: Component | PureComponent) {
    this.component = component

    this.validator = {
      validate: this.validate.bind(component),
      component
    }

    Validation.add(this.validator)
  }

  validate(currentScreen?: string | null) {
    // This function is bound to the component in the constructor so it can modify stuff
    const component: Component | PureComponent = this

    const validation = getValidation(component)

    if (validation) {
      if (!currentScreen || currentScreen === component.context.currentScreen) {
        return validation
          .validate(component.state.value)
          .then(() => {
            component.setState({errorMsg: null})
          })
          .catch((err: any) => {
            component.setState({errorMsg: err.errors[0]})
            throw new Error(`Validation Error: ${err.errors[0]}`)
          })
      }
    }

    return null
  }

  update(prevProps: ValidationProps, prevState: ValidationState = {}) {
    if (this.component.state.value !== prevState.value) {
      const validation = this.validator.validate()
      if (validation) {
        validation.catch((err) => {
          const {props, state} = this.component
          console.log(`${err.message} (field: '${props.name}', value: '${state.value}')`)
        })
      }
    }
  }

  destroy() {
    Validation.remove(this.validator)
  }
}
